// LanguageContext.js

import i18n from "i18next";
import { ReactNode, createContext, useEffect, useState } from "react";
import { initReactI18next } from "react-i18next";

import enJson from "../../assets/locales/en.json";
import huJson from "../../assets/locales/hu.json";

export const resources = {
  en: {
    translations: enJson,
  },
  hu: {
    translations: huJson,
  },
};

export const defaultNS = "translations";

export const LanguageContext = createContext<LanguageContextState>({
  activeLanguage: "en",
  changeLanguage: (language: string) => {},
});

export interface LanguageContextState {
  activeLanguage: string;
  changeLanguage: (language: string) => void;
}

export const LanguageProvider: React.FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const [activeLanguage, setActiveLanguage] = useState("hu"); // Default language is 'en' (English)
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await i18n.use(initReactI18next).init({
        lng: activeLanguage, // Active language
        debug: true, // Enable debug mode for development
        resources,
        defaultNS,
        fallbackLng: ["en", "hu"],
      });
      setLoading(false);
    })();
  }, []);

  const changeLanguage = (language: string) => {
    setActiveLanguage(language);
  };

  return (
    <LanguageContext.Provider value={{ activeLanguage, changeLanguage }}>
      {!loading && children}
    </LanguageContext.Provider>
  );
};
